import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Typography,
  Box,
  Checkbox,
} from "@mui/material";

const StudentTable = ({
  loading,
  filteredData,
  board,
  selectedStudents,
  setSelectedStudents,
}) => {
  const displayValue = (value) => {
    return value?.toString().trim() ? value : "N/A";
  };

  // Select All
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedStudents(filteredData.map((student) => student.admissionNumber));
    } else {
      setSelectedStudents([]);
    }
  };

  // Single Row Select
  const handleSelectStudent = (admissionNumber) => {
    setSelectedStudents((prev) => {
      if (prev.includes(admissionNumber)) {
        return prev.filter((id) => id !== admissionNumber);
      }

      return [...prev, admissionNumber];
    });
  };

  const allSelected =
    filteredData.length > 0 &&
    selectedStudents.length === filteredData.length;

  const someSelected =
    selectedStudents.length > 0 &&
    selectedStudents.length < filteredData.length;

  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 2,
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        maxHeight: "800px",
        overflow: "auto",
      }}
      className="custom-sidebar-scrollbar"
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {/* Checkbox Header */}
            <TableCell
              align="center"
              sx={{
                backgroundColor: "#fff9c4",
                borderRight: "1px solid #ddd",
                padding: "4px",
              }}
            >
              <Checkbox
                checked={allSelected}
                indeterminate={someSelected}
                onChange={handleSelectAll}
              />
            </TableCell>

            <TableCell
              align="center"
              sx={{
                borderRight: "1px solid #ddd",
                padding: "4px",
                backgroundColor: "#fff9c4",
                fontWeight: "bold",
              }}
            >
              S.No
            </TableCell>

            <TableCell
              align="center"
              sx={{
                borderRight: "1px solid #ddd",
                padding: "4px",
                backgroundColor: "#fff9c4",
                fontWeight: "bold",
              }}
            >
              Admission No
            </TableCell>

            <TableCell
              align="center"
              sx={{
                borderRight: "1px solid #ddd",
                padding: "4px",
                backgroundColor: "#fff9c4",
                fontWeight: "bold",
              }}
            >
              Admission Date
            </TableCell>

            {board === "INTERMEDIATE" && (
              <TableCell
                align="center"
                sx={{
                  borderRight: "1px solid #ddd",
                  padding: "4px",
                  backgroundColor: "#fff9c4",
                  fontWeight: "bold",
                }}
              >
                Course
              </TableCell>
            )}

            <TableCell
              align="center"
              sx={{
                borderRight: "1px solid #ddd",
                padding: "4px",
                backgroundColor: "#fff9c4",
                fontWeight: "bold",
              }}
            >
              {board === "INTERMEDIATE" ? "Year" : "Class"}
            </TableCell>

            <TableCell align="center" sx={{ borderRight: "1px solid #ddd", backgroundColor: "#fff9c4", fontWeight: "bold" }}>
              Section
            </TableCell>

            <TableCell align="center" sx={{ borderRight: "1px solid #ddd", backgroundColor: "#fff9c4", fontWeight: "bold" }}>
              Name
            </TableCell>

            <TableCell align="center" sx={{ borderRight: "1px solid #ddd", backgroundColor: "#fff9c4", fontWeight: "bold" }}>
              Father Name
            </TableCell>

            <TableCell align="center" sx={{ borderRight: "1px solid #ddd", backgroundColor: "#fff9c4", fontWeight: "bold" }}>
              Mother Name
            </TableCell>

            <TableCell align="center" sx={{ borderRight: "1px solid #ddd", backgroundColor: "#fff9c4", fontWeight: "bold" }}>
              Mobile No
            </TableCell>

            <TableCell align="center" sx={{ backgroundColor: "#fff9c4", fontWeight: "bold" }}>
              Gender
            </TableCell>
          </TableRow>
        </TableHead>

        {loading ? (
          <TableBody>
            <TableRow>
              <TableCell colSpan={13}>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  p={2}
                >
                  <CircularProgress />
                  <Typography sx={{ mt: 1 }}>Loading Data...</Typography>
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        ) : filteredData.length === 0 ? (
          <TableBody>
            <TableRow>
              <TableCell colSpan={13} align="center">
                No Data Found
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
          <TableBody>
            {filteredData.map((row, index) => (
              <TableRow key={row.studentId} hover>
                {/* Row Checkbox */}
                <TableCell align="center">
                  <Checkbox
                    checked={selectedStudents.includes(row.admissionNumber)}
                    onChange={() =>
                      handleSelectStudent(row.admissionNumber)
                    }
                  />
                </TableCell>

                <TableCell align="center">{index + 1}</TableCell>

                <TableCell align="center">
                  {displayValue(row.admissionNumber)}
                </TableCell>

                <TableCell align="center">
                  {displayValue(row.admissionDate)}
                </TableCell>

                {board === "INTERMEDIATE" && (
                  <TableCell align="center">
                    {displayValue(row.course)}
                  </TableCell>
                )}

                <TableCell align="center">
                  {displayValue(row.romanNumberClass)}
                </TableCell>

                <TableCell align="center">
                  {displayValue(row.sections)}
                </TableCell>

                <TableCell align="center">
                  {displayValue(row.firstName)} {displayValue(row.lastName)}
                </TableCell>

                <TableCell align="center">
                  {displayValue(row.fathersFirstName)}
                </TableCell>

                <TableCell align="center">
                  {displayValue(row.mothersFirstName)}
                </TableCell>

                <TableCell align="center">
                  {displayValue(row.primaryContact)}
                </TableCell>

                <TableCell align="center">
                  {displayValue(row.gender)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
};

export default React.memo(StudentTable);